import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { FileSizePipe, SharedModule } from '@aiwyn/shared';
import { CrlCategorizationFile, CrlUncategorizedCardVm } from '../../../../models';
import { FileItemIconComponent } from '../../../../../client-requests/containers/client-request-details/client-request-panel/components/file-item-icon/file-item-icon.component';

/**
 * Presentational card rendered below the bulk dropzone (Figma 11281-79682). Shows
 * how many bulk-uploaded files were categorized vs. left uncategorized, and lists
 * the uncategorized ones with a remove control. Fully driven by its `vm` input;
 * the container owns visibility (renders it only while `vm.visible`) and the
 * remove wiring.
 */
@Component({
  selector: 'cxp-crl-uncategorized-files-card',
  templateUrl: './crl-uncategorized-files-card.component.html',
  styleUrls: ['./crl-uncategorized-files-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, FileSizePipe, FileItemIconComponent],
})
export class CrlUncategorizedFilesCardComponent {
  readonly vm = input.required<CrlUncategorizedCardVm>();
  readonly removeFile = output<CrlCategorizationFile>();

  // Starts collapsed; the user expands the file list on demand.
  protected readonly expanded = signal(false);

  protected readonly headerText = computed(() => {
    const { categorizedCount, uncategorizedCount } = this.vm();
    return (
      `We were able to categorize ${categorizedCount} ${pluralizeFile(categorizedCount)}, ` +
      `${uncategorizedCount} ${pluralizeFile(uncategorizedCount)} still uncategorized`
    );
  });

  protected toggle(): void {
    this.expanded.update((value) => !value);
  }

  protected onRemove(file: CrlCategorizationFile): void {
    this.removeFile.emit(file);
  }
}

function pluralizeFile(count: number): string {
  return count === 1 ? 'file' : 'files';
}
